<template>
  <div id="status">
    <el-form label-position="left" class="m-4 text-left">
      <el-form-item label-width="25%" size="mini">
        <template slot="label">
          <i class="fa fa-fw fa-cogs"></i>
          继承
        </template>
        <el-select
          v-model="otherWorkId"
          filterable
          placeholder="请选择工作任务"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.WorkName"
            :value="item.WorkID"
          ></el-option>
        </el-select>
      </el-form-item>
      <div style="display: flex; justify-content: center; align-items: center">
        <van-button
          type="info"
          size="small"
          class="w-25"
          round
          @click="inheritWorkProcess"
          >继 承</van-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "status",
  data () {
    return {
      options: [],
      otherWorkId: ""
    };
  },
  props: {
    data: Object
  },
  methods: {
    // 获取工作任务列表
    getWorkList () {
      this.apiWorkGet({}, this, res => {
        if (res.code == 20000) {
          let workId = this.data.WorkID
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].WorkID !== workId) {
              this.options.push(res.data[i])
            }
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 继承其他工作任务工作流程
    inheritWorkProcess () {
      let process = this.getProcess()
      if (process == "dutyuser") {
        // 继承其他工作任务保密室值班人员
        this.apiInheritDutyUserListAPIGet({
          WorkID: this.data.WorkID,
          OtherWorkID: this.otherWorkId,
          SplitProcessID: this.data.SplitProcessID
        }, this, res => {
          this.$toast(res.message);
          this.$emit('isUpdate')
        });
      } else if (process == "dutyperson") {
        // 继承其他工作任务考务值班人员
        this.apiInheritDutyPersonListAPIGet({
          WorkID: this.data.WorkID,
          OtherWorkID: this.otherWorkId,
          SplitProcessID: this.data.SplitProcessID
        }, this, res => {
          this.$toast(res.message);
          this.$emit('isUpdate')
        });
      }
    },
  },
  created () {
    this.getWorkList()
  }
};
</script>

<style scoped>
</style>